<template>
    <div class="flex flex-row gap-5">
        <slot />
    </div>
</template>
